export const users = [
  {
    url: '/assets/users/1.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/2.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/3.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/4.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/5.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/6.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/7.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/8.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/9.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/10.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/11.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/12.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/13.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/14.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/15.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/16.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/17.png',
    username: 'sonnysol',
    price: 47.323,
  },
  {
    url: '/assets/users/18.png',
    username: 'sonnysol',
    price: 47.323,
  },
]
